import { FolderKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetMyRoleForFolderByIdRequest, GetMyRoleForFolderByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useMyRoleForFolderByIdQuery(
  req: GetMyRoleForFolderByIdRequest,
  options?: SimpleQueryOptions<GetMyRoleForFolderByIdResponse, GetMyRoleForFolderByIdRequest>
) {
  return useBaseQuery({
    queryKey: [FolderKey.MyRoleForFolderById, String(req.folderId)],
    fnOption: { url: FolderUrl.getMyRoleForFolderById(req.folderId), request: req },
    ...options,
  });
}
